
export default {
  namespaced: true,
  facility_category: {
    title: "Categoria de Instalação | Categorias de Instalações",
    name: "Nome",
    description: "Descrição",
  },
};
